import { render } from "./batteryHealthy.vue?vue&type=template&id=945504fc&scoped=true&ts=true"
import script from "./batteryHealthy.vue?vue&type=script&lang=ts"
export * from "./batteryHealthy.vue?vue&type=script&lang=ts"

import "./batteryHealthy.vue?vue&type=style&index=0&id=945504fc&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945504fc"]])

export default __exports__